// extracted by mini-css-extract-plugin
var _1 = "PdfTemplatePreview-modulePdfTemplatePreview__XgeSE";
export { _1 as "PdfTemplatePreview" }
